import { RequestTypeType, TemplateFieldMetaType, VendorVaultCatalogType } from '@/types/vendorVaultTypes';

export type SelectOptionType = { value: string; label: string };

export const needsBankTemplate = (requestType: RequestTypeType | ''): boolean => requestType === 'intl';

export const getRequestTypeOptions = (catalog: VendorVaultCatalogType): SelectOptionType[] => {
  return (Object.keys(catalog.request_types) as RequestTypeType[]).map((code) => ({
    value: code,
    label: catalog.request_types[code].label,
  }));
};

/** Bank templates. Only meaningful for intl; returns [] for ach and wire so a select renders empty. */
export const getBankOptions = (
  catalog: VendorVaultCatalogType,
  requestType: RequestTypeType | ''
): SelectOptionType[] => {
  return needsBankTemplate(requestType)
    ? Object.entries(catalog.banks).map(([code, bank]) => ({
        value: code,
        label: bank.label,
      }))
    : [];
};

/** The fields the recipient will fill for this request, or null when a bank still has to be chosen. */
export const getTemplateFields = (
  catalog: VendorVaultCatalogType,
  requestType: RequestTypeType | '',
  bank: string | null,
  detailed: boolean
): TemplateFieldMetaType[] | null => {
  if (!requestType) return null;

  const fields = needsBankTemplate(requestType)
    ? bank && catalog.banks[bank]
      ? catalog.banks[bank].fields
      : null
    : catalog.request_types[requestType].fields;

  return fields ? fields.filter((field) => detailed || !field.detailed_only) : null;
};

export const getTemplateLabel = (
  catalog: VendorVaultCatalogType,
  requestType: RequestTypeType | '',
  bank: string | null
): string => {
  if (!requestType) return '';

  if (needsBankTemplate(requestType)) return bank && catalog.banks[bank] ? catalog.banks[bank].label : '';

  return catalog.request_types[requestType].label;
};

export const isDraftTemplate = (
  catalog: VendorVaultCatalogType,
  requestType: RequestTypeType | '',
  bank: string | null
): boolean => {
  return needsBankTemplate(requestType) && !!bank && !!catalog.banks[bank]?.draft;
};
